export default {
  logs: []
}
